// extracted by mini-css-extract-plugin
export default {"root":"V8iHFGN69h","buttonContainer":"vGWExNnF8w","iconContainer":"bGdpCiifv6","name":"atzhvxo84p","info":"n8sBReksK1","icon":"fZnzYyOFRE"};